import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UnsubscribedEmailsService } from '../core/services/unsubscribed_emails.service';

import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-email-unsubscribe',
    templateUrl: './email-unsubscribe.component.html',
    imports: [MatProgressSpinner]
})
export class EmailUnsubscribeComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private unsubscribedEmailService = inject(UnsubscribedEmailsService);

  email: string;
  signature: string;
  unsubscribed: boolean;
  error: string;
  loading = true;

  ngOnInit() {
    this.init();
  }

  private init() {
    this.signature = this.route.snapshot.paramMap.get('signature');
    this.getStatus()
  }

  private getStatus() {
    this.unsubscribedEmailService.getStatus(this.signature).subscribe(result => {
      this.email = result.email;
      this.unsubscribed = result.unsubscribed;
      this.loading = false;
    },
      error => {
        console.log(error.message)
        this.error = "An error occurred. The unsubscribe link may be expired or invalid."
        this.loading = false;
      }
    );
  }

  toggleSubscription() {
    const action = this.unsubscribed ?
      this.unsubscribedEmailService.resubscribe(this.signature) :
      this.unsubscribedEmailService.unsubscribe(this.signature);

    action.subscribe(
      () => {
        this.unsubscribed = !this.unsubscribed;
      },
      error => {
        console.log(error.message)
        this.error = "An error occurred. Please try again.";
      }
    );
  }
}
